import '../../../pro/lib/tooltip/style';
import '../../../pro/lib/modal-provider/style';
import '../../style/index.less';
import './index.less';
// style dependencies
import '../../ripple/style';
import '../../badge/style';
import '../../menu/style';
